var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgCommentSecondaryUserIcon = function SvgCommentSecondaryUserIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 20,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#434343",
    d: "M8 13.174c4.339 0 8 .705 8 3.425C16 19.32 12.315 20 8 20c-4.338 0-8-.705-8-3.425 0-2.721 3.685-3.401 8-3.401M8 0a5.273 5.273 0 0 1 5.294 5.291A5.274 5.274 0 0 1 8 10.583a5.275 5.275 0 0 1-5.294-5.292A5.274 5.274 0 0 1 8 0"
  })));
};
export default SvgCommentSecondaryUserIcon;